import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AutomaticRfQNumberPage } from '@/areas/settings/manufacturing/OrganizationSettings/AutomaticRfQNumberPage';
import { canViewOtherOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/automatic-rfq-number')({
    staticData: {
        access: { permissions: canViewOtherOrganizationSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AutomaticRfQNumberPage />;
}
